/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Noisy_Lamb_FallInputs */

const fr_new_noisy_lamb_fall = /** @type {(inputs: New_Noisy_Lamb_FallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence par créer une section`)
};

/**

* @param {New_Noisy_Lamb_FallInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const new_noisy_lamb_fall = /** @type {((inputs?: New_Noisy_Lamb_FallInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Noisy_Lamb_FallInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_new_noisy_lamb_fall(inputs)
});